import ContentWrapper from "@/components/Core/ContentWrapper";
import mq from "@/utils/mq";
import { render } from "storyblok-rich-text-react-renderer";
import styled, { css } from "styled-components";

const TextOuterContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  display: grid;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  position: relative;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  justify-items: center;
  align-items: center;
  padding-bottom: 3rem;
`;

const TextSectionContainer = styled.div`
  width: 100%;
  max-width: var(--max-content);
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  position: relative;
  gap: 0rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  ${mq.mobile(css`
    gap: 0.5rem;
  `)};
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
  margin-top: -2px;
  ${mq.mobile(css`
    font-size: 24px;
    line-height: 32px;
  `)};
`;

const Text = styled.div`
  color: #d0d6e0;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  * > a {
    color: #4c7c56 !important;
    span {
      color: #4c7c56 !important;
      text-decoration: underline !important;
      text-underline-offset: 2px;
    }
  }

  ${mq.mobile(css`
    margin-top: 8px;
    font-size: 14px;
    line-height: 24px;
    max-width: 100%;
    justify-self: start;
  `)};
`;

export default function FullWidthTextSection({ title, text }) {
  return (
    <ContentWrapper transparent>
      <TextOuterContainer>
        <TextSectionContainer>
          {title && <Title>{title}</Title>}
          <Text>{render(text)}</Text>
        </TextSectionContainer>
      </TextOuterContainer>
    </ContentWrapper>
  );
}
